// src/components/common/BackButton.js
import React from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export default function BackButton({
  to,
  onClick,
  showText = false,
  label = "뒤로가기",
  className = "",
}) {
  const navigate = useNavigate();

  const handleClick = () => {
    if (onClick) return onClick();
    if (to) return navigate(to);
    navigate(-1); // 🔥 기본: 뒤로가기
  };

  return (
    <button
      onClick={handleClick}
      type="button"
      className={`w-8 h-8 flex items-center gap-1 ${className}`}
    >
      <ArrowLeft className="w-6 h-6 text-slate-900" strokeWidth={2} />

      {showText && (
        <span className="text-sm text-slate-900">{label}</span>
      )}
    </button>
  );
}
